/**
 * Region-scoped language metadata for UI switcher and detection.
 */
import { regionConfig } from "../config/regions";

export const LANGUAGE_META = {
  en: { code: "en", label: "English", nativeLabel: "English", dir: "ltr" },
  es: { code: "es", label: "Spanish", nativeLabel: "Español", dir: "ltr" },
  ar: { code: "ar", label: "Arabic", nativeLabel: "العربية", dir: "rtl" },
  fr: { code: "fr", label: "French", nativeLabel: "Français", dir: "ltr" },
  ru: { code: "ru", label: "Russian", nativeLabel: "Русский", dir: "ltr" },
};

export const US_LANGUAGES = ["en", "es", "ar", "fr"];
export const CIS_LANGUAGES = ["ru"];

export function getRegionLanguages() {
  return regionConfig.languages || CIS_LANGUAGES;
}

export function isLanguageAllowed(lang) {
  return getRegionLanguages().includes(lang);
}

export function getLanguageMeta(lang) {
  return LANGUAGE_META[lang] || LANGUAGE_META.en;
}

export function getDefaultLanguage() {
  return regionConfig.default_language || getRegionLanguages()[0] || "en";
}

/** Map UI language to Whisper transcription code (ISO 639-1). */
export function toTranscriptionCode(lang) {
  const map = { en: "en", es: "es", ar: "ar", fr: "fr", ru: "ru" };
  return map[lang] || "en";
}
